import React from "react";
import { Avatar } from "@mui/material";
import { CiCalendar } from "react-icons/ci";
import { GoDownload } from "react-icons/go";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import useCommission from "./hooks/useCommission";
import { GiBackwardTime } from "react-icons/gi";

import { useEffect } from "react";

const ByTeamMemberDetails = () => {
  const navigate = useNavigate();
  const { STAFF_ID } = useParams();
  const { data, method } = useCommission();
  const { teamMemberHistoryList } = data;
  const { teamMemberHistoryListAPI, handleDownloadTeamMemberDetails } = method;

  useEffect(() => {
    if (STAFF_ID) {
      teamMemberHistoryListAPI(STAFF_ID);
    }
  }, [STAFF_ID]);

  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0];
  };

  const formatFullDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      timeZone: "UTC",
    });
  };

  const currencySymbol = "₹";

  return (
    <section>
      <ToastContainer />
      <div className="m-t-3 cus-padd cusheight">
        <header>
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center gap-2">
            <i
                  className="fa-solid fa-angle-left cusgap cursor"
                  onClick={() => navigate(-1)}
                />
            <div className="d-flex align-items-center gap-2">
             <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
             <div>
              <h2 className="page-tittle mb-0">
             
                {teamMemberHistoryList?.staff?.name}
              </h2>
              <span style={{ fontSize: "14px"}}>
            Complete Commission History
              </span>
            </div>
            </div>
            </div>

            <button onClick={()=>handleDownloadTeamMemberDetails(STAFF_ID)}
              className="btn px-4"
              style={{
                background: "linear-gradient(to right, #EA8F80, #F09A8B)",
                color: "#FFF",
                border: "none",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "500",
                paddingBlock: "10px",
              }}
            >
              <GoDownload fontSize={18} style={{ marginRight: "6px" }} />
              Download Report
            </button>
          </div>
          <hr />
        </header>
        <div>
          <div>
            {/* Top Summary Cards */}
            <div className="row g-3 mb-4 align-items-stretch">
              <div className="shadow-sm p-3 h-100 d-flex align-items-center rounded-3">
                <div className="d-flex justify-content-between w-100">
                  <div>
                    <small className="text-muted">
                      Total Earnings (All Time)
                    </small>
                    <h4 className="mb-0">
                      {currencySymbol}{" "}
                      {teamMemberHistoryList?.totalEarningsAllTime}
                    </h4>
                  </div>
                  {/* <div>
                    <small className="text-muted">Assignment Periods</small>
                    <h4 className="mb-0 text-end">
                      {teamMemberHistoryList?.assignmentPeriods}
                    </h4>
                  </div> */}
                </div>
              </div>
            </div>

            {/* Member row list */}
            <div className="d-flex align-items-center gap-1 mb-2">
              <GiBackwardTime fontSize={20} color="#EA8F80" />
              <h5 className="mb-0">Commission History Timeline</h5>
            </div>
            {(!teamMemberHistoryList?.timeline ||
              teamMemberHistoryList?.timeline.length === 0) && (
              <div
                className="d-flex flex-column align-items-center justify-content-center py-5"
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  border: "1px dashed #ddd",
                }}
              >
                <CiCalendar size={40} color="#EC9384" />
                <h6 className="mt-3 mb-1">No Commission History Yet</h6>
                <small className="text-muted text-center">
                  Commission activity for this member will appear here once
                  available.
                </small>
              </div>
            )}
            {teamMemberHistoryList?.timeline?.map((items) => (
              <div
                key={items?.commissionId}
                className="shadow-sm rounded-3 mb-4"
                style={{ background: "#fff" }}
              >
                {/* Header */}
                <div
                  className="p-3 border-bottom"
                  style={{
                    background: "#FFF7F4",
                    borderLeft: "4px solid #EC9384",
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h5 className="mb-1">
                        {items?.groupName}
                        <span
                          className="ms-2 px-2 py-1 rounded-pill"
                          style={{
                            fontSize: "11px",
                            background: "#E8F0FF",
                            color: "#245BFF",
                          }}
                        >
                          {items?.commissionName}
                        </span>
                      </h5>

                      <small className="text-muted d-flex align-items-center gap-1">
                        <CiCalendar fontSize={18} />

                        {/* {`${items?.dateRange?.from} to ${items?.dateRange?.to}`} */}
                        {`${formatFullDate(
                          items?.dateRange?.from
                        )} – ${formatFullDate(items?.dateRange?.to)}`}
                      </small>
                    </div>

                    <div className="text-end">
                      <h4 className="mb-0">₹{items?.earnedInPeriod}</h4>
                      <small className="text-muted">
                        Earned in this period
                      </small>
                    </div>
                  </div>
                </div>

                {/* Summary Stats */}
                <div
                  className="px-4 py-3 border-bottom"
                  style={{ background: "#f8f9fa" }}
                >
                  <div className="d-flex gap-4 text-start">
                    <div>
                      <span style={{ fontSize: "12px" }}>Sales Volume</span>
                      <div style={{ fontSize: "12px" }} className="fw-semibold">
                        ₹{items?.salesVolume}
                      </div>
                    </div>

                    <div>
                      <span style={{ fontSize: "12px" }}>Transactions</span>
                      <div style={{ fontSize: "12px" }} className="fw-semibold">
                        {items?.transactions}
                      </div>
                    </div>

                    <div>
                      <span style={{ fontSize: "12px" }}>
                        Avg Commission / Transaction
                      </span>
                      <div style={{ fontSize: "12px" }} className="fw-semibold">
                        ₹{items?.avgCommissionPerTransaction}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Table */}

                <div className="table-responsive">
                  <table className="table">
                    <thead className="table-light">
                      <tr>
                        <th>Date</th>
                        <th>Sales Amount</th>
                        <th>Commission</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items?.rows?.map((row, i) => (
                        <tr key={row?._id || i}>
                          <td style={{ textAlign: "left" }}>{row?.date}</td>
                          <td style={{ textAlign: "left" }}>
                            {row?.salesAmount}
                          </td>
                          <td
                            className="text-success"
                            style={{ textAlign: "left" }}
                          >
                            {row?.commission}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ByTeamMemberDetails;
